import type { GeneralConfig } from '@shared/types/Config';

export const payoutConfig: GeneralConfig = {
    sortFieldMap: {},
};
